import { MixMenu } from './lc-acl.type';

/**
 * 提供一个方法方便查找菜单树中第一个最深层次的菜单url
 * @param menus
 * @returns
 */
export function findFirstUrl(menus: MixMenu[]) {
  let firstMenu = menus[0];
  let list = firstMenu.menu_list || firstMenu.children;
  if (!list || !list.length) {
    return firstMenu.url;
  }
  return findFirstUrl(list);
}

/**
 * 根据当前模块路径获取当前模块可以访问的第一个路由
 * @param model_path
 * @returns
 */
export function getModelFirstAuthPath(model_path: string, menu_storage_key = 'LCmenus') {
  const LCmenus = JSON.parse(localStorage.getItem(menu_storage_key) || '[]');
  let result_path = '/auth/403';
  if (LCmenus.length > 0) {
    LCmenus.forEach(model_item => {
      if (model_item.url === model_path) {
        result_path = findFirstUrl([model_item]);
      }
    });
  }
  if (result_path !== '/auth/403') {
    let path = result_path.replace(new RegExp(model_path + '/'), '');
    path && (result_path = path);
  }
  return result_path;
}

/**
 * 获取当前menu第一个授权的模块path
 * @param menu_storage_key
 */
export function getMenuFirstAuthModel(menu_storage_key = 'LCmenus') {
  const LCmenus = JSON.parse(localStorage.getItem(menu_storage_key) || '[]');
  let result_path = '';
  if (LCmenus.length) {
    result_path = LCmenus[0].url;
  }
  return result_path;
}
